import { Component, OnInit } from "@angular/core";
import { LoadingService } from "src/app/services/loading.service";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit {
  constructor(public _loadingService: LoadingService) {}

  ngOnInit(): void {}
}
